import { type FlagKey } from '@atbash-labs/ontology-flags'
import { NotFoundPage } from '@axilon-apps/libs-ui-dashboard'

import { useFlag } from './useFlag'

interface FlagRouteProps {
  flag: FlagKey
  children: React.ReactNode
  fallbackHref?: string
}

/**
 * Renders children only when the pinned snapshot enables `flag`. Otherwise
 * the standard NotFoundPage — same bounce as DebugRoute.
 */
export function FlagRoute({ flag, children, fallbackHref = '/chat' }: FlagRouteProps) {
  const enabled = useFlag(flag)
  if (!enabled) return <NotFoundPage href={fallbackHref} />
  return children
}

export default FlagRoute
